module.exports = __webpack_public_path__ + "static/media/menu.0d1ed233.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/restaurant/menu.pdf
// module id = ./src/app/images/restaurant/menu.pdf
// module chunks = 0